module.exports = __webpack_public_path__ + "img/pay1.b6cf8520.png";